
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { batchOrderNotify } from '@/api/order/notify'

@Component({
  name: 'batchOrderNotify',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private ordernumbers!: any[]

  get language () {
    return AppModule.language
  }
  private loading: boolean = false
  private batchOrder: any[] = []
  private orderState: any[] = []

  private checkAll: boolean = false
  private isIndeterminate: boolean = true

  private back () {
    this.$emit('close')
  }
  private async batchNotify () {
    try {
      this.loading = true
      const data: any = {
        ordernumbers: this.ordernumbers
      }
      await batchOrderNotify(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message: 'Operation successfully!',
            type: 'success'
          })
        } else if (this.language === 'zh_cn') {
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        } else if (this.language === 'zh_tw') {
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        }
        this.loading = false
      })
      this.back()
    } catch (e) {
      this.loading = false
    }
  }

  mounted () {}
}
